/**
 * A cartothèque card's phylum (speciesDisplay().phylum, GBIF's name), as
 * the sociétés speak of it and order it: "Ascomycète" first, then
 * "Basidiomycète", then "Myxomycète" (GBIF's Mycetozoa), then any other
 * phylum under its GBIF name, then cards with none. Mirrors src/Phylum.php
 * (the printed cards and exports).
 */
const LABELS = {
  Ascomycota: 'Ascomycète',
  Basidiomycota: 'Basidiomycète',
  Mycetozoa: 'Myxomycète'
};
const ORDER = Object.keys(LABELS);
export function phylumLabel(phylum) {
  if (!phylum || !phylum.trim()) return null;
  return LABELS[phylum] ?? phylum;
}
export function phylumRank(phylum) {
  if (!phylum || !phylum.trim()) return ORDER.length + 1;
  const rank = ORDER.indexOf(phylum);
  return rank === -1 ? ORDER.length : rank;
}
flarum.reg.add('champis-exhibitions', 'forum/utils/phylum', { phylumLabel: phylumLabel,phylumRank: phylumRank, });